// extracted by mini-css-extract-plugin
export var card = "_79-0";
export var expandedCard = "_79-2";
export var paginated = "_79-1";